import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

export default class PopupModalWhite extends PopupBasic {
  private okButton: ButtonScaleViewWithText;
  titleText: LangBitmapFontTextView;

  constructor(opts: { superview: View; close: () => void }) {
    super({
      ...opts,
      zIndex: 10000,
      width: 556,
      height: 455,
      tracking: { feature: 'popup-modal', $subFeature: 'popup-modal-white' },
      skipTitle: true,
    });

    this.box.updateOpts({
      image: `assets/ui/popups/dialog_panel.png`,
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 72, right: 72 },
        vertical: { top: 72, bottom: 72 },
      },
    });
    this.buttonClose.removeFromSuperview();

    this.titleText = new LangBitmapFontTextView({
      superview: this.box,
      color: '#947372',
      size: 40,
      align: 'center',
      verticalAlign: 'center',
      centerOnOrigin: true,
      font: 'Body',
      width: 556,
      height: 88,
      y: 68,
      x: this.box.style.width / 2,
    });

    //  Separator
    new View({
      superview: this.box,
      x: this.box.style.width / 2,
      height: 5,
      width: 443,
      y: 112,
      backgroundColor: '#deedfa',
      centerOnOrigin: true,
    });

    this.okButton = new ButtonScaleViewWithText({
      superview: this.box,
      ...uiConfig.buttons.cancel,
      font: 'Body',
      fontSize: 40,
      localeText: () => i18n('basic.close'),
      onClick: async () => {
        sounds.sfx.play('cancel');
        return opts.close();
      },
      width: 225,
      height: 86,
      x: this.box.style.width / 2,
      y: this.box.style.height - 100,
      labelOffsetX: -10,
      centerOnOrigin: true,
      tracking: {
        feature: 'popup-modal',
        $subFeature: 'popup-modal-white-close',
      },
    });

    this.message.updateOpts({
      x: 40,
      y: 107,
      width: 470,
      height: 200,
      zIndex: 1,
      size: 29,
      color: '#c49291',
    });
  }

  init(opts: {
    title: string;
    message: string;
    tracking: { feature: string; $subFeature: string };
  }) {
    this.opts.tracking = opts.tracking;
    this.okButton.tracking = {
      ...opts.tracking,
      $subFeature: `${opts.tracking.$subFeature}-close`,
    };

    this.titleText.text = opts.title;
    super.init({
      message: opts.message,
    });
  }
}
